import DebugService from '../../services/DebugService';
import config from '../../configs';

import Service from '../../services/Service';
import {API_STATUS} from '../../services/API';

// store
import store from '../../redux/store';
import { addFlowItem } from '../../redux/_AppStore';

/**
 * Service
 * @folder Services
 * @class
 */
class StepsFlowService {

  /**
   * Renvoie l'instance du service
   * @returns {Service} singleton instance
   */
  static getInstance() {
    if (!StepsFlowService._instance) {
      StepsFlowService._instance = new StepsFlowService(store);
    }
    return StepsFlowService._instance;
  }

  constructor(storeArg) {
    this.DEBUG = DebugService.getInstance().enabled;
    if (this.DEBUG) console.log('StepsFlowService - constructor...',{debug:this.DEBUG});
    this.USE_CACHE = !!process.env.REACT_APP_USE_CACHE && process.env.REACT_APP_USE_CACHE === 'true';
    this.store = storeArg;
    this.lastQueryResponse = undefined;
    this.lastAnswerResponse = undefined;
    this.lastAnswerResponse_agent_ids = undefined; // {array of string} response_id des agents qui ont deja ete trigger (timestamp)

    if (this.USE_CACHE) {
      let lastAnswerResponse_agent_ids_cache = localStorage.getItem(config.CACHE_VAR+'_last_agent_ids');
      if (lastAnswerResponse_agent_ids_cache === null) lastAnswerResponse_agent_ids_cache = undefined;
      this.lastAnswerResponse_agent_ids = !!lastAnswerResponse_agent_ids_cache ? JSON.parse(lastAnswerResponse_agent_ids_cache) : undefined;
      if (this.DEBUG) console.log('Service - lastAnswerResponse_agent_ids from localStorage',{lastAnswerResponse_agent_ids:this.lastAnswerResponse_agent_ids});
    }
  }

  init(firstSteps = []) {

  }

  /**
   *
   * @param {string} uservalue
   * @returns {Promise}
   */
  dynamicLoaderAction(uservalue) {
    // faire un service utilisant l'API qui choisit quel step on charge avec quelles valeurs
    if (this.DEBUG) console.log('StepsFlowService - dynamicLoaderAction',{uservalue});

    // on lance la request API
    return this._runQuery(uservalue);
  }



  /**
   * Run the first query
   * @param {string} uservalue
   * @returns {Promise} renvoie un {object} avec les instructions pour lancer l'intent suivant
   */
  _runQuery(uservalue){
    return new Promise((resolve) => {
      if (this.DEBUG) console.log('StepsFlowService - _runQuery',{uservalue});

      // on stocke la valeur
      this.store.dispatch(addFlowItem({query:uservalue}));

      Service.getInstance().runQuery(uservalue)
        .then((response) => {
          // response est un object contenant le body de la reponse, ou bien {status:'error',message:'...'}
          this.lastQueryResponse = response;
          if (this.DEBUG) console.log('StepsFlowService - _runQuery response of API',{response});

          // traitement
          // 2 cas : status = processing ou status = error
          if (this.lastQueryResponse.status === API_STATUS.PROCESSING ||
              this.lastQueryResponse.status === API_STATUS.COMPLETED) {
            // on lance l'écoute d'une reponse (requete reponse tous les Xs)
            this._runAskAnswer()
              .then(v => {
                if (this.DEBUG) console.log('StepsFlowService - _runQuery resolve with',{v});
                resolve(v);
              })
              .catch(err => {
                if (DebugService.getInstance().enabled) console.log('StepsFlowService - _runQuery Something gone wrong',err);
                const nextIntentInstructions = {value:'erreur '+err, trigger: 'error'};
                resolve(nextIntentInstructions);
              });
          }
          else if (this.lastQueryResponse.forceTrigger === 'rate') {
            const intructions = {value:undefined, trigger: 'rateLabel'};
            if (this.DEBUG) console.log('StepsFlowService - _runQuery return forceTrigger',this.lastQueryResponse.forceTrigger);
            // on stocke l'intent dans le store flow
            this.store.dispatch(addFlowItem({session_id:response.session_id,process_id:response.process_id,intructions}));

            resolve(intructions);
          }
          else if (this.lastQueryResponse.forceTrigger === 'end') {
            const intructions = {value:undefined, trigger: 'end'};
            if (this.DEBUG) console.log('StepsFlowService - _runQuery return forceTrigger',this.lastQueryResponse.forceTrigger);
            // on stocke l'intent dans le store flow
            this.store.dispatch(addFlowItem({session_id:response.session_id,process_id:response.process_id,intructions}));

            resolve(intructions);
          }
          else {
            if (DebugService.getInstance().enabled) console.log('StepsFlowService - _runQuery - Something gone wrong :',{message:response.message,status:this.lastQueryResponse.status});

            // cas particulier : si error = Conflict, on renvoie en fonction du statut de la session,
            // soit au user pour refaire une query propre
            // soit au rate, soit au end
            if (false /*response.message === 'Conflict'*/) {
              const intructions = {value:undefined, trigger: 'user'};
              if (this.DEBUG) console.log('StepsFlowService - _runQuery return',{intructions});
              // on stocke l'intent dans le store flow
              this.store.dispatch(addFlowItem({session_id:response.session_id,process_id:response.process_id,intructions}));

              resolve(intructions);
            } else {
              const intructions = {value:{message:response.message}, trigger: 'error'};
              if (this.DEBUG) console.log('StepsFlowService - _runQuery return',{intructions});
              // on stocke l'intent dans le store flow
              this.store.dispatch(addFlowItem({session_id:response.session_id,process_id:response.process_id,intructions}));

              resolve(intructions);
            }
          }
        });

    });
  }

  /**
   * Run the listening to the response of a query
   * @returns renvoie un {object} avec les instructions pour lancer l'intent suivant
   */
  _runAskAnswer(){
    return new Promise((resolve) => {
      if (this.DEBUG) console.log('StepsFlowService - _runAskAnswer',{lastQueryResponse:this.lastQueryResponse,lastAnswerResponse_agent_ids:this.lastAnswerResponse_agent_ids});

      // NB : le requêtage en boucle si DELAYED est déporté dans Service.checkAnswer
      Service.getInstance().checkAnswer(this.lastQueryResponse)
        .then((response) => {
          // response est un object contenant le body de la reponse, ou bien {status:'error',message:'...'}
          if (this.DEBUG) console.log('StepsFlowService - _runAskAnswer response of API',{response});

          // NB le status n'est pas sensé etre DELAYED ni PROCESSING sans messsage_history
          resolve(this._handleAnswerResponse(response));
        });
    });
  }

  /**
   * Run the listening to the response of a query that is processing
   * @returns renvoie un {object} avec les instructions pour lancer l'intent suivant
   */
  reRunAskAnswer(){
    return new Promise((resolve) => {
      if (this.DEBUG) console.log('StepsFlowService - reRunAskAnswer',{lastQueryResponse:this.lastQueryResponse,lastAnswerResponse_agent_ids:this.lastAnswerResponse_agent_ids});

      // NB : le requêtage en boucle si DELAYED est déporté dans Service.checkAnswer
      Service.getInstance().checkAnswer(this.lastQueryResponse)
        .then((response) => {
          // response est un object contenant le body de la reponse, ou bien {status:'error',message:'...'}
          if (this.DEBUG) console.log('StepsFlowService - reRunAskAnswer response of API',{response});

          // NB le status n'est pas sensé etre DELAYED ni PROCESSING sans messsage_history
          resolve(this._handleAnswerResponse(response));
        });
    });
  }

  /**
   * Détermine les instructions en fonction du status de la réponse du check_answer
   * @param {object} response
   * @param {any} previousMessageHistory array of previous message_history, to avoid trigger them again
   * @returns renvoie un {object} avec les instructions pour lancer l'intent suivant
   */
  _handleAnswerResponse(response) {
    const lastStatus = response.status;
    if (lastStatus === API_STATUS.ERROR) {
      if (this.DEBUG) console.log('StepsFlowService - _handleAnswerResponse - Something gone wrong :',{message:response.message});

      const instructions = {value:{message:response.message}, trigger: 'error'};
      if (this.DEBUG) console.log('StepsFlowService - _handleAnswerResponse return',{instructions});
      // on stocke l'intent dans le store flow
      this.store.dispatch(addFlowItem({session_id:response.session_id,process_id:response.process_id,instructions}));

      return instructions;
    }
    else if (lastStatus === API_STATUS.PROCESSING ||
      lastStatus === API_STATUS.ACTIVE ||
      lastStatus === API_STATUS.ABORTED ||    // obsolete
      lastStatus === API_STATUS.COMPLETED ||    // obsolete
      lastStatus === API_STATUS.TERMINATED
    ) {
      if (this.DEBUG && lastStatus === API_STATUS.PROCESSING) console.log('StepsFlowService - _handleAnswerResponse - Session is processing :',{message:response.message});
      if (this.DEBUG && lastStatus === API_STATUS.ACTIVE) console.log('StepsFlowService - _handleAnswerResponse - Session is active :',{message:response.message});
      if (this.DEBUG && lastStatus === API_STATUS.ABORTED) console.log('StepsFlowService - _handleAnswerResponse - Session is aborted (obsolete) :',{message:response.message});
      if (this.DEBUG && lastStatus === API_STATUS.COMPLETED) console.log('StepsFlowService - _handleAnswerResponse - Session is completed (obsolete) :',{message:response.message});
      if (this.DEBUG && lastStatus === API_STATUS.TERMINATED) console.log('StepsFlowService - _handleAnswerResponse - Session is terminated :',{message:response.message});

      // on regarde history et on traite
      // normalement a ce niveau on doit avoir un message_history
      // let message_history = this.lastAnswerResponse.message_history;
      // if (message_history !== undefined) {
      //   message_history = Array.isArray(message_history) ? message_history : [message_history];
      // }

      // on gere le dernier message_history
      let last_message_history = response.message_history ? response.message_history[response.message_history.length-1] : undefined;
      if (this.DEBUG) console.log('StepsFlowService - _handleAnswerResponse - Last message is :',{last_message_history});


      // on transforme le agent en instructions
      let instructions = [];
      if (last_message_history) {
        if (!Array.isArray(last_message_history.agent)) { // ancien format
          last_message_history.agent = [{
            response: last_message_history.agent,
            rich_content: last_message_history.rich_content
          }];
        }
        if (last_message_history.agent) {
          last_message_history.agent.forEach(agent => {
            if (agent) {
              // on verifie qu'on l'a pas deja trigger la derniere fois
              let alreadyTriggered = false;
              if (!!agent.response_id && !!this.lastAnswerResponse_agent_ids && this.lastAnswerResponse_agent_ids.indexOf(agent.response_id) !== -1) {
                alreadyTriggered = true;
              }
              if (!alreadyTriggered) {
                instructions.push({value:agent, trigger: 'rich'});

                // on le memorise
                if (this.lastAnswerResponse_agent_ids === undefined) {
                  this.lastAnswerResponse_agent_ids = [];
                }
                if (!!agent.response_id && this.lastAnswerResponse_agent_ids.indexOf(agent.response_id) === -1) {
                  this.lastAnswerResponse_agent_ids.push(agent.response_id);
                }
                if (this.USE_CACHE) localStorage.setItem(config.CACHE_VAR+'_last_agent_ids',JSON.stringify(this.lastAnswerResponse_agent_ids));
                if (this.DEBUG) console.log('StepsFlowService - handleAnswerResponse, store lastAnswerResponse_agent_ids',{lastAnswerResponse_agent_ids:this.lastAnswerResponse_agent_ids, USE_CACHE:this.USE_CACHE});

              }
            }
          });
        }
      }

      // on ajoute l'instruction de retour d'action
      const continue_requested = response.continue_requested;
      const notation_requested = response.notation_requested;
      // obsolete : si on a COMPLETED, on ajoute le continue
      if (lastStatus === API_STATUS.COMPLETED || !!continue_requested) {
        instructions.push({value:undefined, trigger: 'continueLabel'});
      }
      // si on a le flag notation_requested, on ajoute l'instruction de notation
      else if (!!notation_requested || lastStatus === API_STATUS.ABORTED ||
        lastStatus === API_STATUS.TERMINATED  // on force le reaffichage du rate apres un refresh
      ) {
        instructions.push({value:undefined, trigger: 'rateLabel'});
      }
      // on est en processing, on lui dit de relancer un check_answer
      else if (lastStatus === API_STATUS.PROCESSING) {
        instructions.push({value:undefined, trigger: 'check_answer'});
      }
      // sinon, user
      else {
        instructions.push({value:undefined, trigger: 'user'});
      }
      if (this.DEBUG) console.log('StepsFlowService - _handleAnswerResponse return',{instructions});


      this.lastAnswerResponse = response;

      // on stocke l'intent dans le store flow
      this.store.dispatch(addFlowItem({session_id:response.session_id,process_id:response.process_id,instructions}));

      return instructions;
    }
    else {
      console.log('StepsFlowService - _handleAnswerResponse - Something gone wrong, status unknown :',{lastStatus,message:response.message});

      const intructions = {value:{message:response.message}, trigger: 'error'};
      if (this.DEBUG) console.log('StepsFlowService - _handleAnswerResponse return',{intructions});
      // on stocke l'intent dans le store flow
      this.store.dispatch(addFlowItem({session_id:response.session_id,process_id:response.process_id,intructions}));

      return intructions;
    }
  }

  /**
   * Bidouille le lastMessage pour tester des cas de réponses en attendant que ca soit possible en back
   * @param {object} lastMessage
   * @returns {object}
   */
  _hackLastMessage(lastMessage) {
    const newLastMessage = lastMessage;
    // TEST DEV
    const ACTIVE_TEST = false;
    if (ACTIVE_TEST) {
      // ajout de html dans agent -------
      newLastMessage.agent = newLastMessage.agent + '\n\nDEV TEST * Ceci est une ligne de text avec du HTML : Please direct all your partnership inquiries to this email address: <a href="mailto:test@test.com">test@test.com</a><br/><ul><li>ligne de texte</li><li>ligne de texte</li><li>ligne de texte</li></ul><nimporte>nimporte quoi</nimporte>';
      // ajout d'un rich_content avec image -------
      if (!!newLastMessage.rich_content && Array.isArray(newLastMessage.rich_content)) {
        newLastMessage.rich_content = [
          ...newLastMessage.rich_content,
          {
            target: 'https://www.bostik.com/france/fr/catalog/product/advanced-packaging/emea/france/product-bostik-france-TLH-2295-ELO/',
            title: 'DEV TEST * TLH 2295 ELO',
            description: 'TLH 2295 ELO est une colle thermofusible sensible à la pression (HMPSA). TLH 2295 ELO est utilisé dans les rubans adhésifs pour l\'automobile.   ',
            image: 'https://www.bostik.com/files/live/sites/shared_bostik/files/Images/France/Header%20Images%204-3/C%26C/Visuels/Fixation%20%26%20Etanch%c3%a9it%c3%a9/bostik-30613547-packaging-avant-afx-110-mastic-fixation-fr',
            type: 'url'
          },
        ];
      } else if(!!newLastMessage.rich_content) {
        // on le transforme en array
        newLastMessage.rich_content = [
          newLastMessage.rich_content,
          {
            target: 'https://www.bostik.com/france/fr/catalog/product/advanced-packaging/emea/france/product-bostik-france-TLH-2295-ELO/',
            title: 'DEV TEST * TLH 2295 ELO',
            description: 'TLH 2295 ELO est une colle thermofusible sensible à la pression (HMPSA). TLH 2295 ELO est utilisé dans les rubans adhésifs pour l\'automobile.   ',
            image: 'https://www.bostik.com/files/live/sites/shared_bostik/files/Images/France/Header%20Images%204-3/C%26C/Visuels/Fixation%20%26%20Etanch%c3%a9it%c3%a9/bostik-30613547-packaging-avant-afx-110-mastic-fixation-fr',
            type: 'url'
          },
        ];
      } else {
        newLastMessage.rich_content = [
          {
            target: 'https://www.bostik.com/france/fr/catalog/product/advanced-packaging/emea/france/product-bostik-france-TLH-2295-ELO/',
            title: 'DEV TEST * TLH 2295 ELO',
            description: 'TLH 2295 ELO est une colle thermofusible sensible à la pression (HMPSA). TLH 2295 ELO est utilisé dans les rubans adhésifs pour l\'automobile.   ',
            image: 'https://www.bostik.com/files/live/sites/shared_bostik/files/Images/France/Header%20Images%204-3/C%26C/Visuels/Fixation%20%26%20Etanch%c3%a9it%c3%a9/bostik-30613547-packaging-avant-afx-110-mastic-fixation-fr',
            type: 'url'
          }
        ];
      }
    }
    // fin TEST
    return newLastMessage;
  }

  /**
   *
   * @param {string} uservalue
   * @returns {Promise}
   */
  rateAction(uservalue) {
    // faire un service utilisant l'API pour transmettre le rate
    if (this.DEBUG) console.log('StepsFlowService - rateAction',{uservalue});

    // on lance la request API
    return this._runRate(uservalue);
  }

  /**
   * Run the rate
   * @param {string} uservalue
   * @returns {Promise} renvoie un {object} avec les instructions pour lancer l'intent suivant
   */
  _runRate(uservalue){
    return new Promise((resolve) => {
      if (this.DEBUG) console.log('StepsFlowService - _runRate',{uservalue});

      // on stocke la valeur
      this.store.dispatch(addFlowItem({rate:uservalue}));

      Service.getInstance().transmitRate(uservalue)
        .then((response) => {
          // response est vide si 200, ou bien {status:'error',message:'...'}
          this.lastQueryResponse = response;
          if (this.DEBUG) console.log('StepsFlowService - _runRate response of API',{response});

          // traitement
          const status = this.lastQueryResponse.status;
          if(status === API_STATUS.TERMINATED) { // normalement c'est TERMINATED
            // NB : le clean du session_id dans l'app se fait au moment du click sur le Close,
            // seule action possible du user dans le composant End

            const intructions = {value:uservalue, trigger: 'end'};
            if (this.DEBUG) console.log('StepsFlowService - _runRate return',{intructions});
            // on stocke l'intent dans le store flow
            this.store.dispatch(addFlowItem({intructions}));

            resolve(intructions);
          }
          else if (status === API_STATUS.PROCESSING) {  // en cas de conflict
            // on fiat un check_answer
            this._runAskAnswer()
            .then(v => {
              console.log('StepsFlowService - _runRate _runAskAnswer resolve with',{v});
              resolve(v);
            })
            .catch(err => {
              if (DebugService.getInstance().enabled) console.log('StepsFlowService - _runQuery Something gone wrong',err);
              const nextIntentInstructions = {value:'erreur '+err, trigger: 'error'};
              resolve(nextIntentInstructions);
            });
          }
          else {
            console.log('StepsFlowService - _runRate - Something gone wrong :',{status, message:response.message});

            const intructions = {value:{message:response.message}, trigger: 'error'};
            if (this.DEBUG) console.log('StepsFlowService - _runRate return',{intructions});
            // on stocke l'intent dans le store flow
            this.store.dispatch(addFlowItem({intructions}));

            resolve(intructions);
          }
        });

    });
  }

  /**
   * Clear cache and reset conversation
   */
  reset() {
    this.lastQueryResponse = undefined;
    this.lastAnswerResponse = undefined;
    this.lastAnswerResponse_agent_ids = undefined;
    if (this.USE_CACHE) localStorage.removeItem(config.CACHE_VAR+'_last_agent_ids');
    if (this.DEBUG) console.log('StepsFlowService - Reseted.');
    Service.getInstance().reset();
  }

}

StepsFlowService._instance = null;

export default StepsFlowService;
